import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { getHoveredOrganization } from '../../../api/organizations';

import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';

export const fetchOrganizationHovercard = createAsyncThunk(
  'organizations/fetchOrganizationHovercard',
  async ({ path }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const response = await getHoveredOrganization(
        { path },
        {
          cancelToken: source.token,
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
);

export const fetchOrganizationHovercardExtraReducers = builder => {
  builder
    .addCase(fetchOrganizationHovercard.pending, (state, action) => {
      const organizationId = action.meta.arg.path.orgId;
      checkAndSetLoadingWithId(
        state.organizations.organization.request,
        action,
        organizationId,
      );
    })
    .addCase(fetchOrganizationHovercard.fulfilled, (state, action) => {
      const organizationId = action.meta.arg.path.orgId;
      onMatchedRequest(
        state.organizations.organization.request[organizationId],
        action,
        () => {
          state.organizations.organization.byId[organizationId] = {
            ...action.payload,
          };
          if (
            !state.organizations.organization.allIds.includes(organizationId)
          ) {
            state.organizations.organization.allIds.push(organizationId);
          }
        },
      );
    })
    .addCase(fetchOrganizationHovercard.rejected, (state, action) => {
      const organizationId = action.meta.arg.path.orgId;
      handleRequestRejection(
        state.organizations.organization.request[organizationId],
        action,
      );
    });
};
